import {
    Modale,
    ModaleTitre,
    ModaleContent,
    ModaleFooter,
    GroupeBouton,
    Bouton,
} from '@design-system-etat/dsfr-react';
import React from 'react';
import PropTypes from 'prop-types';

const ModaleArmeNonSoumiseADeclaration2011 = ({ etapeSuivante, fermerModale, retourArriere }) => {
    return (
        <>
            <Modale taille="lg" closeCallback={fermerModale}>
                <ModaleTitre>Ajouter une arme absente du râtelier</ModaleTitre>
                <ModaleContent>
                    <p>
                        Les informations correspondent à une arme acquise avant le 1er décembre 2011
                        (décret n°2011-1523 du 7 octobre 2011)
                    </p>
                    <p>
                        Il n&apos;est pas obligatoire de déclarer cette arme mais vous pouvez le
                        faire afin qu&apos;elle soit ajoutée à votre râtelier numérique.
                    </p>
                </ModaleContent>
                <ModaleFooter>
                    <GroupeBouton alignementHorizontal="right" isHorizontal>
                        <Bouton label="Ne pas déclarer cette arme" onClick={retourArriere} />
                        <Bouton
                            label="Déclarer cette arme"
                            niveau="primaire"
                            onClick={etapeSuivante}
                        />
                    </GroupeBouton>
                </ModaleFooter>
            </Modale>
        </>
    );
};

ModaleArmeNonSoumiseADeclaration2011.propTypes = {
    etapeSuivante: PropTypes.func.isRequired,
    fermerModale: PropTypes.func.isRequired,
    retourArriere: PropTypes.func.isRequired,
};

export default ModaleArmeNonSoumiseADeclaration2011;
